// krida-ui-pile-details.js - Pile Details Modal handling
import { createCardElement } from './card-renderer.js';
import { computePileValue, calculateTotalPilePoints_UI } from './krida-ui-board.js';
import { showErrorModal } from './krida-ui-error.js';

// --- Initialization ---
// No longer need a separate init, dependencies are imported.

// --- Pile Details Modal ---
export function showPileDetailsModal(pileData) {
  closePileDetailsModal(); // Close existing modal first

  const detailsModal = document.createElement('div');
  detailsModal.id = 'pile-details-modal';
  detailsModal.className = 'modal';

  const modalContent = document.createElement('div');
  modalContent.className = 'modal-content';

  const modalHeader = document.createElement('div');
  modalHeader.className = 'modal-header';
  const title = document.createElement('div');
  title.className = 'modal-title';
  title.textContent = 'Pile Details';
  const closeBtn = document.createElement('span');
  closeBtn.className = 'close-btn';
  closeBtn.innerHTML = '&times;';
  closeBtn.onclick = closePileDetailsModal;
  modalHeader.appendChild(title);
  modalHeader.appendChild(closeBtn);

  const modalBody = document.createElement('div');
  modalBody.className = 'modal-body';
  modalBody.id = 'pile-details-content';

  modalContent.appendChild(modalHeader);
  modalContent.appendChild(modalBody);
  detailsModal.appendChild(modalContent);

  // Populate content
  const visibleCards = pileData.visible || [];
  const hiddenCards = pileData.hidden || [];
  const totalCards = visibleCards.length + hiddenCards.length;
  const pileValue = computePileValue(pileData);
  const pilePoints = calculateTotalPilePoints_UI(pileData);

  const summarySection = document.createElement('div');
  summarySection.className = 'pile-summary-section modal-section';
  summarySection.innerHTML = `
    <h3>Pile Summary</h3>
    <p>Total Cards: ${totalCards}</p>
    <p>Visible Cards: ${visibleCards.length}</p>
    <p>Hidden Cards: ${hiddenCards.length}</p>
    <p>Pile Value: ${pileValue}</p>
    <p>Total Points: ${pilePoints}</p>
  `;
  modalBody.appendChild(summarySection);

  const cardsSection = document.createElement('div');
  cardsSection.className = 'pile-cards-section modal-section';

  if (visibleCards.length > 0) {
    cardsSection.appendChild(_createCardsGrid('Visible Cards', visibleCards, false));
  }
  if (hiddenCards.length > 0) {
    cardsSection.appendChild(_createCardsGrid('Hidden Cards (Revealed)', hiddenCards, true));
  }
  modalBody.appendChild(cardsSection);

  document.body.appendChild(detailsModal);
  detailsModal.style.display = 'block';
}

// Helper to create a grid of cards
function _createCardsGrid(titleText, cards, markHidden) {
    const container = document.createElement('div');
    container.innerHTML = `<h3>${titleText}</h3>`;
    const grid = document.createElement('div');
    grid.className = 'modal-card-grid';
    grid.style.gridTemplateColumns = 'repeat(auto-fill, minmax(70px, 1fr))';
    cards.forEach(card => {
      const cardEl = createCardElement(card, true); // Always show face up in modal
      cardEl.style.transform = 'scale(0.7)';
      if (markHidden) cardEl.classList.add('previously-hidden');
      grid.appendChild(cardEl);
    });
    container.appendChild(grid);
    return container;
}

export function closePileDetailsModal() {
  const modal = document.getElementById('pile-details-modal');
  if (modal) {
    modal.remove();
  }
} 